/* eslint-disable */

import ControlPanel from "views/Control Panel/ControlPanel";
// eslint-disable-next-line no-unused-vars
import WhatsHappening from "views/Orchestration/WhatsHappening/WhatsHappening.js";
import ProgramSetup from "views/ProgramSetup/ProgramSetup";
import Login from "views/Login/Login.js";
import initiativesManagement from "views/InitiativesProgram/initiativesManagement.js";
import TermsOfUse from "views/Extras/TermsOfUse";
import NoPermission from "views/NoPermission/NoPermission";

import AssignmentIcon from "@material-ui/icons/Assignment";
import BuildIcon from "@material-ui/icons/Build";
import EventNoteIcon from "@material-ui/icons/EventNote";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { Visibility, FilterList, AssignmentTurnedIn } from "@material-ui/icons";
import RiskManagement from "views/Orchestration/RiskManagement";
import ProgramMeetingManagement from "views/Orchestration/ProgramMeetingManagement";
import KPIsPage from "views/KPIs/KPIsPage";
import CentralUploads from "views/ProgramManagement/CentralUploads";
import WhatsHappeningV2 from "views/Orchestration/WhatsHappening/WhatsHappeningV2";
import WhatsHappeningV3 from "views/Orchestration/WhatsHappening/WhatsHappeningV3";
import WhatsHappeningV4 from "views/Orchestration/WhatsHappening/WhatsHappeningV4";
import WhatsHappeningV5 from "views/Orchestration/WhatsHappening/WhatsHappeningV5";
import WhatsHappeningV8 from "views/Orchestration/WhatsHappening/WhatsHappeningV8";

// Funções utilitárias para clonagem e alteração de layout
function deepClone(obj) {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map(deepClone);
  }
  const clonedObj = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      clonedObj[key] = deepClone(obj[key]);
    }
  }
  return clonedObj;
}

function changeLayoutToMain(obj) {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (key === "layout") {
        obj[key] = "/main";
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        changeLayoutToMain(obj[key]);
      }
    }
  }
}

// Definição das rotas extras
const extrasRoutes = [
  {
    collapse: true,
    name: "sidebar_toffice.extras",
    active: true, // Página ativa
    icon: MoreHorizIcon,
    state: "ExtrasCollapse",
    layout: "/extras",
    views: [
      {
        path: "/terms-of-use",
        name: "sidebar_toffice.extras_menu.terms_of_use",
        active: true,
        mini: "sidebar_toffice.extras_menu_mini.terms_of_use",
        component: TermsOfUse,
        layout: "/extras",
      },
      {
        external_link: "https://integrationconsulting.com/en/privacy-policy/",
        name: "sidebar_toffice.extras_menu.privacy_policy",
        active: true,
        mini: "sidebar_toffice.extras_menu_mini.privacy_policy",
        layout: "/extras",
      },
    ],
  },
];

// Clonagem para mudar o layout para /main
const extrasRoutesInMain = deepClone(extrasRoutes);
changeLayoutToMain(extrasRoutesInMain);

// Definição das rotas principais
// const dashRoutes = [
//   // 1. Orquestração
//   {
//     collapse: true,
//     name: "sidebar_toffice.orchestration",
//     active: true,
//     icon: Visibility,
//     state: "orchestrationCollapse",
//     layout: "/main",
//     views: [
//       {
//         path: "/whats-happening",
//         name: "sidebar_toffice.orchestration_menu.whats_happening",
//         active: true,
//         mini: "sidebar_toffice.orchestration_menu_mini.whats_happening",
//         component: WhatsHappeningV2,
//         layout: "/main",
//       },
//       {
//         path: "/meeting-management",
//         name: "sidebar_toffice.orchestration_menu.meeting_management",
//         active: true,
//         mini: "sidebar_toffice.orchestration_menu_mini.meeting_management",
//         component: ProgramMeetingManagement,
//         layout: "/main",
//       },
//       {
//         path: "/program-risk-management",
//         name: "sidebar_toffice.orchestration_menu.program_risk_management",
//         active: true,
//         mini: "sidebar_toffice.orchestration_menu_mini.program_risk_management",
//         component: RiskManagement,
//         layout: "/main",
//       },
//     ],
//   },
//   // 2. KPIs
//   {
//     collapse: true,
//     name: "sidebar_toffice.kpis",
//     active: true,
//     icon: Assessment,
//     state: "kpisCollapse",
//     layout: "/main",
//     views: [
//       {
//         path: "/evolution",
//         name: "sidebar_toffice.kpis_menu.evolution",
//         active: true,
//         mini: "sidebar_toffice.kpis_menu_mini.evolution",
//         component: KPIsPage,
//         layout: "/main",
//       },
//     ],
//   },
//   // 3. Initiatives Management
//   {
//     path: "/initiatives-management",
//     name: "sidebar_toffice.initiatives_management",
//     active: true,
//     icon: AssignmentIcon,
//     component: initiativesManagement,
//     layout: "/main",
//   },
//   // 4. Program Management
//   {
//     collapse: true,
//     name: "sidebar_toffice.program_management",
//     active: true,
//     icon: BuildIcon,
//     state: "programManagementCollapse",
//     layout: "/main",
//     views: [
//       {
//         path: "/program-setup",
//         name: "sidebar_toffice.program_management_menu.program_setup",
//         active: true,
//         mini: "sidebar_toffice.program_management_menu_mini.program_setup",
//         component: ProgramSetup,
//         layout: "/main",
//       },
//       {
//         path: "/control-panel",
//         name: "sidebar_toffice.program_management_menu.control_panel",
//         active: true,
//         mini: "sidebar_toffice.program_management_menu_mini.control_panel",
//         component: ControlPanel,
//         layout: "/main",
//       },
//       {
//         path: "/upload-results",
//         name: "sidebar_toffice.program_management_menu.upload_results",
//         active: true,
//         mini: "sidebar_toffice.program_management_menu_mini.upload_results",
//         component: CentralUploads,
//         layout: "/main",
//       },
//     ],
//   },
//   // Página de login
//   {
//     path: "/login",
//     name: "sidebar_toffice.login",
//     active: true,
//     component: Login,
//     layout: "/auth",
//   },
//   // Página de permissão negada
//   {
//     path: "/no-permission",
//     name: "sidebar_toffice.no_permission",
//     active: true,
//     icon: EventNoteIcon,
//     component: NoPermission,
//     layout: "/main",
//     showOnlyWhenRedirected: true,
//   },
//   ...extrasRoutes,
//   ...extrasRoutesInMain,
// ];

export default function buildDashRoutes(userDetails = {}) {
  // NEW

  /* ───── Flags vindas do POST-login (valores default = TRUE) ──── */
  const {
    has_meeting_management: hasMeetingManagement = true,
    has_risks_management: hasRisksManagement = true,
    has_portfolio_management: hasPortfolioManagement = true,
    //has_value_tree: hasValueTree = true,
    has_whats_happening: hasWhatsHappening = true,
    has_kpi_evolution: hasKpiEvolution = true,
    has_program_set_up: hasProgramSetUp = true,
    has_control_panel: hasControlPanel = true,
    has_central_upload: hasCentralUpload = true,
    whats_happening_version: whatsVersion = "WhatsHappening",
    permissions = {},
  } = userDetails;

  /* Mapa versão → componente ------------------------------------- */
  const whatsComponentMap = {
    WhatsHappening: WhatsHappening,
    WhatsHappeningV2: WhatsHappeningV2,
    WhatsHappeningV3: WhatsHappeningV3,
    WhatsHappeningV4: WhatsHappeningV4,
    WhatsHappeningV5: WhatsHappeningV5,
    WhatsHappeningV8: WhatsHappeningV8,
  };
  const WhatsComponent = whatsComponentMap[whatsVersion] || WhatsHappening;

  /* ----------------------------------------------------------------
     3.  ROTAS PRINCIPAIS)
     ---------------------------------------------------------------- */
  const dashRoutes = [
    /* 1. VISIBILITY & RHYTHM ------------------------------------ */
    {
      collapse: true,
      name: "sidebar_toffice.visibility",
      // The whole menu is active if the user can access this module
      active: permissions.can_access_visibility_and_rhythm,
      icon: Visibility,
      state: "visibilityCollapse",
      layout: "/main",
      views: [
        {
          path: "/whats-happening",
          name: "sidebar_toffice.visibility_menu.whats_happening",
          mini: "WH",
          component: WhatsComponent,
          // Individual items are also controlled by module permission or more specific flags if needed
          active: hasWhatsHappening && permissions.can_access_visibility_and_rhythm,
          layout: "/main",
        },
        {
          path: "/kpis-evolution",
          name: "sidebar_toffice.visibility_menu.kpis",
          mini: "KE",
          component: KPIsPage,
          active: hasKpiEvolution && permissions.can_access_visibility_and_rhythm, // Controlled by the main module flag
          layout: "/main",
        },
        {
          path: "/program-risk-management",
          name: "sidebar_toffice.visibility_menu.program_risk_management",
          mini: "RM",
          component: RiskManagement,
          active: hasRisksManagement && permissions.can_access_risk_module, // Specific permission for this submodule
          layout: "/main",
        },
        {
          path: "/meeting-management",
          name: "sidebar_toffice.visibility_menu.meeting_management",
          mini: "MM",
          component: ProgramMeetingManagement,
          active: hasMeetingManagement && permissions.can_access_meeting_management, // Specific permission for this submodule
          layout: "/main",
        },
      ],
    },

    /* 2. EXECUTION ORCHESTRATION ------------------------------- */
    {
      collapse: true,
      name: "sidebar_toffice.execution",
      active: permissions.can_access_execution_orchestration,
      icon: AssignmentTurnedIn,
      state: "executionCollapse",
      layout: "/main",
      views: [
        {
          path: "/initiatives-management",
          name: "sidebar_toffice.execution_menu.initiatives_management",
          mini: "IM",
          component: initiativesManagement,
          active: permissions.can_view_initiatives, // Controlled by the ability to see the initiative list
          layout: "/main",
        },
      ],
    },

    /* 3. PORTFOLIO ------------------------------------------- */
    {
      collapse: true,
      name: "sidebar_toffice.portfolio",
      active: hasPortfolioManagement && permissions.can_access_portfolio,
      icon: FilterList,
      state: "portfolioCollapse",
      layout: "/main",
      views: [
        {
          path: "/prioritization",
          name: "sidebar_toffice.portfolio_menu.prioritization",
          mini: "PR",
          component: NoPermission, // Placeholder, permission can be refined later
          active: permissions.can_access_portfolio,
          layout: "/main",
        },
        {
          path: "/initiatives-stages",
          name: "sidebar_toffice.portfolio_menu.initiatives_stages",
          mini: "IS",
          component: NoPermission, // Placeholder, permission can be refined later
          active: permissions.can_access_portfolio,
          layout: "/main",
        },
      ],
    },

    /* 4. PROGRAM SETUP --------------------------------------- */
    {
      collapse: true,
      name: "sidebar_toffice.program_management",
      // The menu is active if the user can manage the setup OR access the central upload.
      active:
        permissions.can_manage_program_setup ||
        permissions.can_access_central_upload ||
        permissions.can_access_control_panel,
      icon: BuildIcon,
      state: "programManagementCollapse",
      layout: "/main",
      views: [
        {
          path: "/program-setup",
          name: "sidebar_toffice.program_management_menu.program_setup",
          mini: "PS",
          component: ProgramSetup,
          active: hasProgramSetUp && permissions.can_manage_program_setup,
          layout: "/main",
        },
        {
          path: "/control-panel",
          name: "sidebar_toffice.program_management_menu.control_panel",
          mini: "CP",
          component: ControlPanel,
          active: hasControlPanel && permissions.can_access_control_panel, // Specific permission
          layout: "/main",
        },
        {
          path: "/upload-results",
          name: "sidebar_toffice.program_management_menu.upload_results",
          mini: "UR",
          component: CentralUploads,
          active: hasCentralUpload && permissions.can_access_central_upload, // Specific permission
          layout: "/main",
        },
      ],
    },

    /* 5. UTILITY ROUTES (Always active) ---------------------- */
    {
      path: "/login",
      name: "sidebar_toffice.login",
      active: true,
      component: Login,
      layout: "/auth",
    },
    {
      path: "/no-permission",
      name: "sidebar_toffice.no_permission",
      active: true,
      icon: EventNoteIcon,
      component: NoPermission,
      layout: "/main",
      showOnlyWhenRedirected: true,
    },
  ];

  /* ----------------------------------------------------------------
     4.  UNE tudo, filtra e devolve
     ---------------------------------------------------------------- */
  const allRoutes = [...dashRoutes, ...extrasRoutes, ...extrasRoutesInMain];

  // Função para filtrar apenas as rotas ativas (caso active esteja false, descarta)
  function filterActiveRoutes(routes) {
    return routes
      .filter((route) => route.active !== false)
      .map((route) => {
        if (route.views) {
          const filteredViews = filterActiveRoutes(route.views);
          // Hide the parent collapse menu if it has no active children
          if (filteredViews.length === 0) {
            return { ...route, active: false };
          }
          return { ...route, views: filteredViews };
        }
        return route;
      })
      .filter((route) => route.active !== false); // Final filter to remove empty parent menus
  }

  return filterActiveRoutes(allRoutes);
}

//export default filterActiveRoutes(dashRoutes);
